export default __webpack_public_path__ + "static/media/error-camera.f55d3a05.svg";